webpackJsonp([100629050728319],{

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _formatting = __webpack_require__(49);
	
	var _markdown = __webpack_require__(22);
	
	var _siteMetadata = __webpack_require__(72);
	
	var _Articles = __webpack_require__(540);
	
	var _Articles2 = _interopRequireDefault(_Articles);
	
	var _Metadata = __webpack_require__(73);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _NextPreviousNav = __webpack_require__(209);
	
	var _NextPreviousNav2 = _interopRequireDefault(_NextPreviousNav);
	
	var _Page = __webpack_require__(108);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Meta = _styledComponents2.default.header.withConfig({
	  displayName: 'ArticlesPage__Meta'
	})(['text-align:center;']);
	
	var ArticlesPage = function ArticlesPage(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  var previousPath = pathContext.previousPath,
	      nextPath = pathContext.nextPath;
	
	
	  var nav = _react2.default.createElement(_NextPreviousNav2.default, {
	    previousLabel: 'Newer',
	    previousPath: previousPath,
	    nextLabel: 'Older',
	    nextPath: nextPath
	  });
	
	  return _react2.default.createElement(
	    _Page2.default,
	    {
	      title: (0, _formatting.pluralise)((0, _siteMetadata.articlesResourceTitle)(data)),
	      navTop: nav,
	      navBottom: nav
	    },
	    _react2.default.createElement(_Metadata2.default, (0, _siteMetadata.articlesPageMetadata)(data)),
	    _react2.default.createElement(
	      Meta,
	      null,
	      (0, _formatting.pagination)(pathContext)
	    ),
	    _react2.default.createElement(_Articles2.default, { articles: (0, _markdown.markdownItemNodes)(data), pagination: pathContext })
	  );
	};
	ArticlesPage.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.object.isRequired
	};
	
	exports.default = ArticlesPage;
	module.exports = exports['default'];

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ArticlesPage = __webpack_require__(499);
	
	var _ArticlesPage2 = _interopRequireDefault(_ArticlesPage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _ArticlesPage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ArticleFooterMeta = __webpack_require__(161);
	
	var _ArticleFooterMeta2 = _interopRequireDefault(_ArticleFooterMeta);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _ArticleFooterMeta2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _renderListItems = __webpack_require__(98);
	
	var _renderListItems2 = _interopRequireDefault(_renderListItems);
	
	var _VList = __webpack_require__(115);
	
	var _VList2 = _interopRequireDefault(_VList);
	
	var _ArticlesListItem = __webpack_require__(101);
	
	var _ArticlesListItem2 = _interopRequireDefault(_ArticlesListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArticlesList = function ArticlesList(_ref) {
	  var articles = _ref.articles;
	  return _react2.default.createElement(
	    _VList2.default,
	    null,
	    (0, _renderListItems2.default)(_ArticlesListItem2.default, 'article', articles)
	  );
	};
	
	ArticlesList.propTypes = {
	  articles: _propTypes2.default.array.isRequired
	};
	
	exports.default = ArticlesList;
	module.exports = exports['default'];

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cssapi = __webpack_require__(4);
	
	var _gatsbyLink = __webpack_require__(138);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _markdown = __webpack_require__(22);
	
	var _VLayout = __webpack_require__(19);
	
	var _VLayout2 = _interopRequireDefault(_VLayout);
	
	var _TextLink = __webpack_require__(33);
	
	var _TextLink2 = _interopRequireDefault(_TextLink);
	
	var _TitleSecondary = __webpack_require__(119);
	
	var _TitleSecondary2 = _interopRequireDefault(_TitleSecondary);
	
	var _spaceChildrenH = __webpack_require__(55);
	
	var _spaceChildrenH2 = _interopRequireDefault(_spaceChildrenH);
	
	var _spaceChildrenV = __webpack_require__(34);
	
	var _spaceChildrenV2 = _interopRequireDefault(_spaceChildrenV);
	
	var _ArticleFooterMeta = __webpack_require__(99);
	
	var _ArticleFooterMeta2 = _interopRequireDefault(_ArticleFooterMeta);
	
	var _ArticleHeadMeta = __webpack_require__(162);
	
	var _ArticleHeadMeta2 = _interopRequireDefault(_ArticleHeadMeta);
	
	var _PolyImage = __webpack_require__(109);
	
	var _PolyImage2 = _interopRequireDefault(_PolyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = _styledComponents2.default.div.withConfig({
	  displayName: 'ArticlesListItem__Layout'
	})(['display:flex;', ';', ';', ';> *:first-child{', ';}'], (0, _cssapi.api)({
	  flexDirection: ['column', 'column', 'row']
	}), (0, _spaceChildrenH2.default)([0, 0, '1.5ru']), (0, _spaceChildrenV2.default)(['1ru', '1ru', 0]), (0, _cssapi.api)({
	  flex: ['0 0 auto', '0 0 auto', '0 0 33.3%']
	}));
	
	var TextLayout = (0, _styledComponents2.default)(_VLayout2.default).withConfig({
	  displayName: 'ArticlesListItem__TextLayout'
	})(['flex:0 0 auto;']);
	
	var ArticlesListItem = function ArticlesListItem(_ref) {
	  var article = _ref.article;
	
	  var title = (0, _markdown.fieldsTitle)(article);
	  var color = (0, _markdown.fieldsColor)(article);
	  return _react2.default.createElement(
	    Layout,
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: (0, _markdown.fieldsSlug)(article), title: title },
	      _react2.default.createElement(_PolyImage2.default, { imageSizes: (0, _markdown.frontmatterImageSizes)(article), color: color })
	    ),
	    _react2.default.createElement(
	      TextLayout,
	      { spacing: 'small' },
	      _react2.default.createElement(
	        _TextLink2.default,
	        { to: (0, _markdown.fieldsSlug)(article), title: title, underlineType: 'left' },
	        _react2.default.createElement(
	          _TitleSecondary2.default,
	          null,
	          title
	        )
	      ),
	      _react2.default.createElement(_ArticleHeadMeta2.default, { article: article }),
	      _react2.default.createElement(
	        'p',
	        null,
	        article.excerpt
	      ),
	      _react2.default.createElement(_ArticleFooterMeta2.default, { article: article })
	    )
	  );
	};
	
	ArticlesListItem.propTypes = {
	  article: _propTypes2.default.object.isRequired
	};
	
	exports.default = ArticlesListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(1);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ArticleList = __webpack_require__(100);
	
	var _ArticleList2 = _interopRequireDefault(_ArticleList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Articles = function Articles(_ref) {
	  var articles = _ref.articles;
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    (0, _ramda.isEmpty)(articles) ? _react2.default.createElement(
	      'div',
	      null,
	      'No Articles Yet'
	    ) : _react2.default.createElement(_ArticleList2.default, { articles: articles })
	  );
	};
	
	Articles.propTypes = {
	  articles: _propTypes2.default.array.isRequired
	};
	
	exports.default = Articles;
	module.exports = exports['default'];

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Articles = __webpack_require__(102);
	
	var _Articles2 = _interopRequireDefault(_Articles);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Articles2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.LayoutNext = exports.LayoutPrevious = undefined;
	
	var _cssapi = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ArrowButtonLink = __webpack_require__(213);
	
	var _ArrowButtonLink2 = _interopRequireDefault(_ArrowButtonLink);
	
	var _DisabledArrowButtonLink = __webpack_require__(214);
	
	var _DisabledArrowButtonLink2 = _interopRequireDefault(_DisabledArrowButtonLink);
	
	var _flexHorizontal = __webpack_require__(54);
	
	var _flexHorizontal2 = _interopRequireDefault(_flexHorizontal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LayoutPrevious = exports.LayoutPrevious = _styledComponents2.default.div.withConfig({
	  displayName: 'NextPreviousNav__LayoutPrevious'
	})(['']);
	var LayoutNext = exports.LayoutNext = _styledComponents2.default.div.withConfig({
	  displayName: 'NextPreviousNav__LayoutNext'
	})(['']);
	
	var Layout = _styledComponents2.default.nav.withConfig({
	  displayName: 'NextPreviousNav__Layout'
	})(['', ';justify-content:space-between;letter-spacing:0.06em;', ',', '{', ';}'], _flexHorizontal2.default, LayoutNext, LayoutPrevious, (0, _cssapi.api)({
	  width: {
	    default: 'calc(50% - 2px)',
	    mediumUp: 'calc(50% - 0.25ru)'
	  }
	}));
	
	var previousPathLink = function previousPathLink(previousPath, label) {
	  return previousPath ? _react2.default.createElement(
	    _ArrowButtonLink2.default,
	    { to: previousPath, direction: 'left' },
	    label
	  ) : _react2.default.createElement(
	    _DisabledArrowButtonLink2.default,
	    { direction: 'left' },
	    label
	  );
	};
	
	var nextPathLink = function nextPathLink(nextPath, label) {
	  return nextPath ? _react2.default.createElement(
	    _ArrowButtonLink2.default,
	    { to: nextPath, direction: 'right' },
	    label
	  ) : _react2.default.createElement(
	    _DisabledArrowButtonLink2.default,
	    { direction: 'right' },
	    label
	  );
	};
	
	var NextPreviousNav = function NextPreviousNav(_ref) {
	  var previousPath = _ref.previousPath,
	      nextPath = _ref.nextPath,
	      previousLabel = _ref.previousLabel,
	      nextLabel = _ref.nextLabel;
	  return _react2.default.createElement(
	    Layout,
	    null,
	    _react2.default.createElement(
	      LayoutPrevious,
	      null,
	      previousPathLink(previousPath, previousLabel)
	    ),
	    _react2.default.createElement(
	      LayoutNext,
	      null,
	      nextPathLink(nextPath, nextLabel)
	    )
	  );
	};
	
	NextPreviousNav.propTypes = {
	  previousPath: _propTypes2.default.string,
	  nextPath: _propTypes2.default.string,
	  previousLabel: _propTypes2.default.string,
	  nextLabel: _propTypes2.default.string
	};
	
	NextPreviousNav.defaultProps = {
	  previousPath: null,
	  nextPath: null,
	  previousLabel: 'Previous',
	  nextLabel: 'Next'
	};
	
	exports.default = NextPreviousNav;

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PolyImage = __webpack_require__(163);
	
	var _PolyImage2 = _interopRequireDefault(_PolyImage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _PolyImage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['1.4ru'], ['1.4ru']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['0.5ru 1ru'], ['0.5ru 1ru']);
	
	var _cssapi = __webpack_require__(4);
	
	var _ramda = __webpack_require__(1);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _directionBounce = __webpack_require__(215);
	
	var _directionBounce2 = _interopRequireDefault(_directionBounce);
	
	var _arrow = __webpack_require__(121);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	var _singleLineTruncate = __webpack_require__(217);
	
	var _singleLineTruncate2 = _interopRequireDefault(_singleLineTruncate);
	
	var _ButtonLink = __webpack_require__(112);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Wrapper = _styledComponents2.default.div.withConfig({
	  displayName: 'ArrowButtonLink__Wrapper'
	})(['position:relative;z-index:1;text-align:center;', ':0;', ';&:hover{animation:', ' 0.3s ease-in-out;}'], (0, _ramda.prop)('direction'), (0, _arrow2.default)((0, _cssapi.scope)(_templateObject), 'c:backgroundInverted'), function (_ref) {
	  var direction = _ref.direction;
	  return (0, _directionBounce2.default)(direction);
	});
	
	var Link = (0, _styledComponents2.default)(_ButtonLink2.default).withConfig({
	  displayName: 'ArrowButtonLink__Link'
	})(['display:block;', ';', ';'], _singleLineTruncate2.default, (0, _cssapi.api)({
	  padding: (0, _cssapi.scope)(_templateObject2)
	}));
	
	var ArrowButtonLink = function ArrowButtonLink(props) {
	  return _react2.default.createElement(
	    Wrapper,
	    props,
	    _react2.default.createElement(Link, props)
	  );
	};
	
	exports.default = ArrowButtonLink;
	module.exports = exports['default'];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _linkProps = __webpack_require__(42);
	
	var _linkProps2 = _interopRequireDefault(_linkProps);
	
	var _BaseLink = __webpack_require__(51);
	
	var _BaseLink2 = _interopRequireDefault(_BaseLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = (0, _styledComponents2.default)(_BaseLink2.default).withConfig({
	  displayName: 'ButtonLink__Button'
	})(['', ';font-weight:normal;display:block;', ';'], (0, _linkProps2.default)('c:textInverted', 'c:highlight'), (0, _cssapi.api)({
	  color: 'c:textInverted',
	  backgroundColor: 'c:backgroundInverted'
	}));
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['1.4ru'], ['1.4ru']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['0.5ru 1ru'], ['0.5ru 1ru']);
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _arrow = __webpack_require__(121);
	
	var _arrow2 = _interopRequireDefault(_arrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var DisabledArrowButtonLink = _styledComponents2.default.div.withConfig({
	  displayName: 'DisabledArrowButtonLink'
	})(['z-index:1;position:relative;display:block;cursor:default;color:transparent;user-select:none;', ';', ';'], (0, _arrow2.default)((0, _cssapi.scope)(_templateObject), 'c:disabled'), (0, _cssapi.api)({
	  padding: (0, _cssapi.scope)(_templateObject2),
	  backgroundColor: 'c:disabled'
	}));
	
	exports.default = DisabledArrowButtonLink;
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _uiList = __webpack_require__(164);
	
	var _uiList2 = _interopRequireDefault(_uiList);
	
	var _VLayout = __webpack_require__(19);
	
	var _VLayout2 = _interopRequireDefault(_VLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VList = (0, _styledComponents2.default)(_VLayout2.default.withComponent('ul')).withConfig({
	  displayName: 'VList'
	})(['', ';'], _uiList2.default);
	
	exports.default = VList;
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(3);
	
	var _api3 = __webpack_require__(120);
	
	var _api4 = _interopRequireDefault(_api3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var directionBounce = function directionBounce(direction) {
	  var _api, _api2;
	
	  return (0, _styledComponents.keyframes)(['0%{', ':0;}60%{', '}85%{', '}100%{', ':0;}'], direction, (0, _api4.default)((_api = {}, _api[direction] = '-0.5rem', _api)), (0, _api4.default)((_api2 = {}, _api2[direction] = '0.2rem', _api2)), direction);
	};
	
	exports.default = directionBounce;
	module.exports = exports['default'];

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var arrow = function arrow(api, props) {
	  return function () {
	    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '16';
	    var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'red';
	
	    var translation = props.direction === 'right' ? '50%' : '-50%';
	    return (0, _styledComponents.css)(['::after{content:\'\';z-index:-1;position:absolute;bottom:50%;transform:translate(', ',50%) rotate(45deg);', ':0;', ';}'], translation, props.direction, api({
	      width: size,
	      height: size,
	      background: background
	    }));
	  };
	};
	
	exports.default = (0, _cssapi.mixin)(arrow);
	module.exports = exports['default'];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _styledComponents = __webpack_require__(3);
	
	var singleLineTruncate = (0, _styledComponents.css)(['white-space:nowrap;overflow:hidden;text-overflow:ellipsis;']);
	
	exports.default = singleLineTruncate;
	module.exports = exports['default'];

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _graphql = __webpack_require__(58);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _ArticlesPage = __webpack_require__(500);
	
	var _ArticlesPage2 = _interopRequireDefault(_ArticlesPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ArticlesPage2.default;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-components-templates-articles-js-1dd4d647cc160ca4c74e.js